// SLIDER
var aboutCarousel = document.querySelector('.co-about-section-3-carousel');

if (aboutCarousel) {
  var aboutFlkty = new Flickity(aboutCarousel, {
    cellAlign: "left",
    groupCells: true,
    contain: true,
    prevNextButtons: true,
    pageDots: false,
    freeScroll: true,
    // wrapAround: true,
    // autoPlay: 3000,
    on: {
      ready: function() {

      }
    }
  });

  // Trackpad / mouse-wheel free scrolling.
  // A two-finger horizontal swipe on a Mac trackpad fires `wheel` events with a
  // non-zero deltaX (and a decaying stream of them during momentum). Map that
  // delta straight onto Flickity's free-scroll position so the trackpad feels
  // exactly like dragging, instead of paging. Vertical gestures are left untouched
  // so the page still scrolls normally past this section.
  aboutCarousel.addEventListener('wheel', function (event) {
    var dx = event.deltaX;
    var dy = event.deltaY;

    // Only react to predominantly horizontal swipes so we never hijack the
    // page's vertical scrolling (and skip pure-vertical / zero-delta noise).
    if (Math.abs(dx) <= Math.abs(dy)) return;
    if (!aboutFlkty.slides || !aboutFlkty.slides.length) return;

    event.preventDefault(); // keep the swipe on the carousel (no native h-scroll / swipe-back)

    // Move by the swipe amount, clamped to the same bounds Flickity uses while
    // dragging a contained free-scroll slider.
    var maxX = -aboutFlkty.slides[0].target;            // start of the track
    var minX = -aboutFlkty.getLastSlide().target;       // end of the track
    var x = Math.min(maxX, Math.max(minX, aboutFlkty.x - dx));

    aboutFlkty.x = x;
    aboutFlkty.velocity = 0;       // we position directly; no leftover coasting
    aboutFlkty.positionSlider();   // render the new position

    // Keep the prev/next arrows in sync with the free-scrolled position.
    var pos = -x;
    var nearest = 0;
    var best = Infinity;
    for (var i = 0; i < aboutFlkty.slides.length; i++) {
      var d = Math.abs(aboutFlkty.slides[i].target - pos);
      if (d < best) { best = d; nearest = i; }
    }
    aboutFlkty.selectedIndex = nearest;
  }, { passive: false });
}